module.exports = __webpack_public_path__ + "static/media/koude-schotel.ddb519d1.jpg";